// Figma: https://www.figma.com/design/iYlbYhvyJjh7X00UAcqCWt/About-page?node-id=13-1103
import { Box, Flex, Text } from "@chakra-ui/react";
import { MissionBadge } from "./MissionBadge";
import { AnimatedAboutText } from "./AnimatedAboutText";

export function HeroSection() {
  return (
    <Flex
      position="relative"
      zIndex={2}
      direction="column"
      align="center"
      pt="120px"
      pb="80px"
      px="24px"
      maxW="960px"
      mx="auto"
    >
      {/* Header (13:1103) — "About" SVG overlaps above "GlobalComix" */}
      <Box position="relative">
        {/* "About" in Mandoul Brush as SVG (13:1111) — animated write-on */}
        <AnimatedAboutText />
        {/* "GlobalComix" (13:1105) */}
        <Text
          fontSize={{ base: "56px", md: "80px" }}
          fontWeight="600"
          color="dune.dune"
          fontFamily="'Bricolage Grotesque', sans-serif"
          lineHeight="1.1"
        >
          GlobalComix
        </Text>
      </Box>

      {/* Bottom group (13:1106) — gap-20 between badge and subtext */}
      <Flex direction="column" align="center" gap="20px" mt="48px">
        {/* Mission badge (13:1107) */}
        <MissionBadge />

        {/* Mission statement (13:1110) */}
        <Text
          fontSize="24px"
          fontWeight="400"
          color="dune.700"
          fontFamily="'Roboto', sans-serif"
          textAlign="center"
          lineHeight="1.4"
          maxW="600px"
        >
          GlobalComix is building the home for comics and manga communities
          online.
        </Text>
      </Flex>
    </Flex>
  );
}
